export interface IBuildTimeSeriesQueryParams {
  timeDimension?: string;
}

const build = (time?: string) => {
  if (!time) return '';
  return `TIMESERIES ${time}`;
};

const parse = (query: string): string | undefined => {
  const match = query.match(/\bTIMESERIES\s+(\S+)/i);
  return match?.[1];
};

export { build as buildTimeSeriesQuery, parse as parseTimeSeriesQuery };
